(()=>{
function clean(s){
  return String(s??'')
    .replace(/[–—]/g,'-')
    .replace(/[‘’]/g,"'")
    .replace(/[“”]/g,'"')
    .replace(/[^\x20-\x7E]/g,' ');
}
function pdfEsc(s){return clean(s).replace(/\\/g,'\\\\').replace(/\(/g,'\\(').replace(/\)/g,'\\)')}
function rgb(hex){
  hex=hex.replace('#','');
  return [parseInt(hex.slice(0,2),16)/255,parseInt(hex.slice(2,4),16)/255,parseInt(hex.slice(4,6),16)/255]
}
const C={
  ink:rgb('#171719'), muted:rgb('#74757B'), line:rgb('#E7E8EC'),
  pink:rgb('#E8343F'), coral:rgb('#E98A55'), teal:rgb('#249FA3'), violet:rgb('#8571B8'),
  soft:rgb('#F7F7F9')
};
function fmt(n){return Number(n).toFixed(3)}
function text(x,y,size,s,font='F1',color=C.ink){
  return `${fmt(color[0])} ${fmt(color[1])} ${fmt(color[2])} rg BT /${font} ${size} Tf 1 0 0 1 ${fmt(x)} ${fmt(y)} Tm (${pdfEsc(s)}) Tj ET\n`
}
function line(x1,y1,x2,y2,w=1,color=C.line){
  return `${fmt(color[0])} ${fmt(color[1])} ${fmt(color[2])} RG ${fmt(w)} w ${fmt(x1)} ${fmt(y1)} m ${fmt(x2)} ${fmt(y2)} l S\n`
}
function rect(x,y,w,h,fill=null,stroke=null,sw=1){
  let out='';
  if(fill) out+=`${fmt(fill[0])} ${fmt(fill[1])} ${fmt(fill[2])} rg `;
  if(stroke) out+=`${fmt(stroke[0])} ${fmt(stroke[1])} ${fmt(stroke[2])} RG ${fmt(sw)} w `;
  out+=`${fmt(x)} ${fmt(y)} ${fmt(w)} ${fmt(h)} re `;
  out+=fill&&stroke?'B\n':fill?'f\n':'S\n';
  return out
}
function circle(cx,cy,r,stroke,colorFill=null,sw=4){
  const k=.5522847498*r;
  let out='';
  if(colorFill)out+=`${fmt(colorFill[0])} ${fmt(colorFill[1])} ${fmt(colorFill[2])} rg `;
  if(stroke)out+=`${fmt(stroke[0])} ${fmt(stroke[1])} ${fmt(stroke[2])} RG ${fmt(sw)} w `;
  out+=`${fmt(cx+r)} ${fmt(cy)} m `+
    `${fmt(cx+r)} ${fmt(cy+k)} ${fmt(cx+k)} ${fmt(cy+r)} ${fmt(cx)} ${fmt(cy+r)} c `+
    `${fmt(cx-k)} ${fmt(cy+r)} ${fmt(cx-r)} ${fmt(cy+k)} ${fmt(cx-r)} ${fmt(cy)} c `+
    `${fmt(cx-r)} ${fmt(cy-k)} ${fmt(cx-k)} ${fmt(cy-r)} ${fmt(cx)} ${fmt(cy-r)} c `+
    `${fmt(cx+k)} ${fmt(cy-r)} ${fmt(cx+r)} ${fmt(cy-k)} ${fmt(cx+r)} ${fmt(cy)} c `;
  out+=colorFill&&stroke?'B\n':colorFill?'f\n':'S\n';
  return out
}
function wrap(s,maxChars){
  const words=clean(s).split(/\s+/),lines=[];let row='';
  words.forEach(w=>{
    const t=row?row+' '+w:w;
    if(t.length>maxChars && row){lines.push(row);row=w}else row=t
  });
  if(row)lines.push(row);
  return lines
}
function para(x,y,size,s,maxChars=75,leading=16,font='F1',color=C.muted,maxLines=12){
  let out='',yy=y;
  wrap(s,maxChars).slice(0,maxLines).forEach(row=>{out+=text(x,yy,size,row,font,color);yy-=leading});
  return {out,y:yy}
}
function bar(x,y,w,value,color=C.pink){
  return rect(x,y,w,7,C.line)+rect(x,y,w*Math.max(0,Math.min(100,value))/100,7,color)
}
function radar(cx,cy,R,p){
  const vals=[p.adv,p.heat,p.acid,p.texture,p.sweet,p.intensity].map(Number);
  let out='';
  [1,.72,.45].forEach(scale=>{
    const pts=[];
    for(let i=0;i<6;i++){const a=(-90+i*60)*Math.PI/180;pts.push([cx+Math.cos(a)*R*scale,cy+Math.sin(a)*R*scale])}
    out+=`${fmt(C.line[0])} ${fmt(C.line[1])} ${fmt(C.line[2])} RG 1 w ${fmt(pts[0][0])} ${fmt(pts[0][1])} m `;
    pts.slice(1).forEach(pt=>out+=`${fmt(pt[0])} ${fmt(pt[1])} l `);out+='h S\n'
  });
  const pts=[];
  for(let i=0;i<6;i++){const a=(-90+i*60)*Math.PI/180,r=R*(vals[i]||0)/100;pts.push([cx+Math.cos(a)*r,cy+Math.sin(a)*r])}
  out+=`${fmt(C.pink[0])} ${fmt(C.pink[1])} ${fmt(C.pink[2])} RG 2 w ${fmt(pts[0][0])} ${fmt(pts[0][1])} m `;
  pts.slice(1).forEach(pt=>out+=`${fmt(pt[0])} ${fmt(pt[1])} l `);out+='h S\n';
  return out
}
function pageHeader(title,subtitle=''){
  let c=text(46,796,10,'TASTE PROFILE','F2',C.muted);
  c+=text(46,748,34,title,'F2',C.ink);
  if(subtitle)c+=text(46,720,14,subtitle,'F1',C.muted);
  c+=line(46,698,549,698,1,C.line);
  return c
}
function pageFooter(num,url){
  return line(46,45,549,45,1,C.line)+text(46,25,8,clean(url||'Taste Profile Test'),'F1',C.muted)+text(530,25,8,String(num),'F2',C.muted)
}
function cuisineRows(cuisines,y){
  let out='';
  (cuisines||[]).slice(0,4).forEach((c,i)=>{
    out+=text(46,y,12,String(i+1).padStart(2,'0'),'F2',C.ink);
    out+=text(86,y,9,clean(c[0]),'F2',C.muted);
    out+=text(168,y,13,clean(c[1]),'F2',C.ink);
    out+=text(507,y,12,`${c[2]}%`,'F2',C.pink);
    const p=para(168,y-18,9,c[3],66,12,'F1',C.muted,2);out+=p.out;
    out+=line(46,y-47,549,y-47,1,C.line);y-=72
  });
  return out
}
function placeRows(places,y){
  let out='';
  (places||[]).slice(0,5).forEach((item,i)=>{
    const p=item.place||item;
    const label=item.category||p.primaryOccasion||'Match';
    out+=text(46,y,9,clean(label).toUpperCase(),'F2',C.muted);
    out+=text(145,y,14,clean(p.name),'F2',C.ink);
    out+=text(503,y,12,`${p.match||''}${p.match?'%':''}`,'F2',C.pink);
    const meta=[p.price,p.area,p.rating?`Rating ${Number(p.rating).toFixed(1)}`:''].filter(Boolean).join(' - ');
    out+=text(145,y-18,9,clean(meta),'F1',C.muted);
    const d=para(145,y-34,9,p.description||'Strong match for this Taste Profile.',62,12,'F1',C.muted,2);out+=d.out;
    out+=line(46,y-63,549,y-63,1,C.line);y-=88
  });
  return out
}
function makeStreams(data){
  const p=data.profile||{},cuisines=data.cuisines||[],places=data.places||[],compare=data.compare||null,url=data.url||'';
  const pages=[];

  // Page 1 cover
  let s='';
  s+=text(46,792,11,'TASTE PROFILE','F2',C.muted);
  s+=text(46,695,54,"You're",'F2',C.ink);
  s+=text(46,630,54,clean(p.name||'Your profile')+'.','F2',C.pink);
  const q=para(46,576,20,p.tagline||'',44,27,'F2',C.ink,4);s+=q.out;
  const intro=para(46,490,11,p.copy||'',80,16,'F1',C.muted,6);s+=intro.out;
  const stats=[['Adventure',p.adv,C.pink],['Heat',p.heat,C.coral],['Acid',p.acid,C.teal],['Sweet',p.sweet,C.violet]];
  let x=46;
  stats.forEach(([label,v,col])=>{
    s+=text(x,275,27,String(v),'F2',C.ink);
    s+=text(x,252,8,label.toUpperCase(),'F2',C.muted);
    s+=bar(x,232,105,Number(v)||0,col);
    x+=128
  });
  s+=text(46,90,10,'A behavioural food-preference profile - not a medical or genetic assessment.','F1',C.muted);
  s+=pageFooter(1,url);pages.push(s);

  // Page 2 profile data
  s=pageHeader('Your taste signature.','One profile, a few different views.');
  s+=radar(160,500,105,p);
  const labels=[['Adventure',p.adv],['Heat',p.heat],['Intensity',p.intensity],['Acid',p.acid],['Texture',p.texture],['Sweet',p.sweet]];
  let y=615;
  labels.forEach(([lab,v])=>{s+=text(305,y,11,lab,'F2',C.ink);s+=bar(390,y-2,125,Number(v)||0,C.pink);s+=text(525,y,11,String(v),'F2',C.ink);y-=43});
  s+=text(46,332,22,'What stands out','F2',C.ink);
  const insights=[
    `Adventure ${p.adv}: how naturally you move towards the unfamiliar.`,
    `Heat ${p.heat}: how much chilli adds pleasure rather than friction.`,
    `Acid ${p.acid}: how much sharpness wakes food up for you.`,
    `Sweet ${p.sweet}: how much sweetness contributes to satisfaction.`
  ];
  y=292;insights.forEach((t,i)=>{s+=circle(58,y+4,5,null,[C.pink,C.coral,C.teal,C.violet][i]);const pp=para(76,y,10,t,77,14,'F1',C.muted,2);s+=pp.out;y-=56});
  s+=pageFooter(2,url);pages.push(s);

  // Page 3 cuisine matches
  s=pageHeader('Your flavour world.','Cuisines your answers suggest you should explore.');
  s+=text(46,665,17,'Cuisine matches','F2',C.ink);
  s+=cuisineRows(cuisines,625);
  const cuisineNote=para(46,250,10,'These are inferred matches from the Taste Profile dimensions, not cuisines you selected during the test.',78,15,'F1',C.muted,4);s+=cuisineNote.out;
  s+=pageFooter(3,url);pages.push(s);

  // Page 4 restaurant recommendations
  const placeTitle=data.placeTitle||'Where we would send you';
  s=pageHeader(placeTitle,'Five places matched to the way you like to eat.');
  s+=placeRows(places,645);
  if(!places||!places.length){
    const none=para(46,610,11,'Choose a city on the live results page to add local restaurant recommendations to your next download.',78,16,'F1',C.muted,4);s+=none.out;
  }
  s+=text(46,105,10,'Open your unique result again','F2',C.ink);
  const u4=para(46,84,8,url,90,11,'F1',C.muted,4);s+=u4.out;
  s+=pageFooter(4,url);pages.push(s);

  // Optional Page 5 comparison
  if(compare){
    s=pageHeader('Table Chemistry.','How the two completed profiles compare.');
    s+=text(46,642,48,`${compare.score}%`,'F2',C.pink);
    s+=text(178,654,22,clean(compare.headline||'Your table match'),'F2',C.ink);
    const pp=para(178,624,10,compare.copy||'',55,15,'F1',C.muted,5);s+=pp.out;
    s+=text(46,508,16,'Trait comparison','F2',C.ink);
    const keys=[['Adventure','adv'],['Heat','heat'],['Intensity','intensity'],['Acid','acid'],['Texture','texture'],['Sweet','sweet']];
    y=468;
    keys.forEach(([lab,k])=>{
      s+=text(46,y,10,lab,'F2',C.ink);
      s+=bar(135,y-2,165,Number(p[k])||0,C.pink);
      s+=bar(320,y-2,165,Number(compare.other?.[k])||0,C.teal);
      y-=43
    });
    s+=text(135,188,9,'YOU','F2',C.pink)+text(320,188,9,clean(compare.otherName||'OTHER PROFILE'),'F2',C.teal);
    s+=pageFooter(5,url);pages.push(s);
  }
  return pages
}
function buildPdf(data){
  const streams=makeStreams(data);
  const objects=[];
  const add=s=>{objects.push(s);return objects.length};
  const font1=add('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>');
  const font2=add('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold >>');
  const pageIds=[],contentIds=[];
  streams.forEach(stream=>{
    const bytes=new TextEncoder().encode(stream);
    const cid=add(`<< /Length ${bytes.length} >>\nstream\n${stream}endstream`);
    contentIds.push(cid);
    const pid=add('PENDING');
    pageIds.push(pid);
  });
  const pagesId=add('PAGES_PENDING');
  const catalogId=add(`<< /Type /Catalog /Pages ${pagesId} 0 R >>`);
  pageIds.forEach((pid,i)=>{
    objects[pid-1]=`<< /Type /Page /Parent ${pagesId} 0 R /MediaBox [0 0 595 842] /Resources << /Font << /F1 ${font1} 0 R /F2 ${font2} 0 R >> >> /Contents ${contentIds[i]} 0 R >>`
  });
  objects[pagesId-1]=`<< /Type /Pages /Kids [${pageIds.map(id=>`${id} 0 R`).join(' ')}] /Count ${pageIds.length} >>`;

  let pdf='%PDF-1.4\n%\xE2\xE3\xCF\xD3\n',offsets=[0];
  objects.forEach((obj,i)=>{offsets.push(new TextEncoder().encode(pdf).length);pdf+=`${i+1} 0 obj\n${obj}\nendobj\n`});
  const xref=new TextEncoder().encode(pdf).length;
  pdf+=`xref\n0 ${objects.length+1}\n0000000000 65535 f \n`;
  for(let i=1;i<offsets.length;i++)pdf+=String(offsets[i]).padStart(10,'0')+' 00000 n \n';
  pdf+=`trailer\n<< /Size ${objects.length+1} /Root ${catalogId} 0 R >>\nstartxref\n${xref}\n%%EOF`;
  return new TextEncoder().encode(pdf)
}
function download(data,filename='taste-profile-full-results.pdf'){
  const bytes=buildPdf(data);
  const blob=new Blob([bytes],{type:'application/pdf'});
  const a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download=filename;
  document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(a.href),1500)
}
window.TasteProfilePDFV132={buildPdf,download};
})();